import React, { useState, Component } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarIcon, UserIcon, TagIcon, SearchIcon, BookOpenIcon } from 'lucide-react';
import Button from '../components/Button';
import Wizard from '../components/Wizard';
import BlogPost from './BlogPost';
import WhatIsGPTStore from './posts/WhatIsGPTStore';
import HowToAccessGPTStore from './posts/HowToAccessGPTStore';
import CatalogDataQuality from './posts/CatalogDataQuality';
import SEORecommendations from './SEORecommendations';
import { Helmet } from 'react-helmet';
// Sample blog post data - expanded to 15 articles
const blogPosts = [{
  id: 0,
  title: "It's not me, it's you: The Real Problem in AI Commerce",
  excerpt: "In AI commerce, the real problem is rarely the agent — it's the catalog feed. Amazon just rang the alarm bell: over 74,000 outdated variation themes are being deprecated. Every retailer must update their ASINs by November 2025 or risk losing visibility.",
  date: 'September 10, 2023',
  author: 'Ben Geva',
  category: 'AI Retail',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/f44aHP4XWcsXXBqXG8GYEL/blog_image.jpg',
  slug: 'catalog-data-quality',
  featured: true
}, {
  id: 1,
  title: 'What is the GPT Store? A Complete Guide for Brands (2025)',
  excerpt: "Executive guide to OpenAI's GPT Store: what it is, why it matters for brands, how publishing works, common pitfalls, monetization options, and how Shopilots helps you launch and profit fast.",
  date: 'August 25, 2023',
  author: 'Shopilots Team',
  category: 'GPT Store',
  image: 'https://images.unsplash.com/photo-1677442135167-8df7c658d4e0?q=80&w=1932&auto=format&fit=crop',
  slug: 'what-is-the-gpt-store'
}, {
  id: 2,
  title: 'How to Access and Publish in the GPT Store',
  excerpt: "Step-by-step guide on accessing and publishing your brand's GPT in the OpenAI GPT Store, including requirements, common errors, and how Shopilots helps brands launch without friction.",
  date: 'August 20, 2023',
  author: 'Ben Johnson',
  category: 'GPT Store',
  image: 'https://images.unsplash.com/photo-1676099677237-a0a828532125?q=80&w=2070&auto=format&fit=crop',
  slug: 'how-to-access-gpt-store'
}, {
  id: 3,
  title: 'How AI is Transforming the Retail Experience',
  excerpt: 'Discover how AI-powered shopping advisors are changing the way customers interact with brands and make purchasing decisions.',
  date: 'August 15, 2023',
  author: 'Sarah Johnson',
  category: 'AI Retail',
  image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'how-ai-is-transforming-retail'
}, {
  id: 4,
  title: 'The Future of GPT Stores: What Retailers Need to Know',
  excerpt: 'GPT Stores are emerging as a new sales channel. Learn how your brand can leverage this technology to stay ahead of the competition.',
  date: 'July 28, 2023',
  author: 'Michael Chen',
  category: 'GPT Technology',
  image: 'https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'future-of-gpt-stores'
}, {
  id: 5,
  title: 'Increasing Conversion Rates with AI Shopping Advisors',
  excerpt: 'Case studies and strategies showing how AI shopping advisors have helped retailers boost their conversion rates by up to 35%.',
  date: 'June 12, 2023',
  author: 'Alex Rivera',
  category: 'Conversion Optimization',
  image: 'https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'increasing-conversion-rates'
}, {
  id: 6,
  title: 'AI Ethics in Retail: Balancing Innovation and Customer Trust',
  excerpt: 'How to implement AI in your retail business while maintaining transparency and building customer trust.',
  date: 'May 24, 2023',
  author: 'Jordan Lee',
  category: 'AI Ethics',
  image: 'https://images.unsplash.com/photo-1502810365585-56ffa361fdde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'ai-ethics-in-retail'
}, {
  id: 7,
  title: 'SEO Improvement Plan for AI Shopping Platforms',
  excerpt: 'A comprehensive strategy to enhance visibility for AI shopping advisors and GPT Store solutions in both traditional search and AI-powered discovery.',
  date: 'May 10, 2023',
  author: 'Emma Rodriguez',
  category: 'SEO Strategy',
  image: 'https://images.unsplash.com/photo-1571721795195-a2d50c1b62b0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'seo-recommendations'
}, {
  id: 8,
  title: 'Implementing WhatsApp AI Shopping Assistants',
  excerpt: 'Step-by-step guide to deploying AI shopping advisors on WhatsApp to reach customers where they already communicate.',
  date: 'April 18, 2023',
  author: 'David Kim',
  category: 'Implementation',
  image: 'https://images.unsplash.com/photo-1633675254053-d96c7668c3b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'whatsapp-ai-assistants'
}, {
  id: 9,
  title: 'How to Measure ROI from AI Shopping Advisors',
  excerpt: 'Key metrics and measurement strategies to evaluate the return on investment from your AI shopping advisor implementation.',
  date: 'April 5, 2023',
  author: 'Priya Patel',
  category: 'Analytics',
  image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'measuring-ai-roi'
}, {
  id: 10,
  title: 'Personalization at Scale with AI Shopping Advisors',
  excerpt: 'How AI enables truly personalized shopping experiences for thousands of customers simultaneously without increasing staff costs.',
  date: 'March 22, 2023',
  author: 'Thomas Wilson',
  category: 'Personalization',
  image: 'https://images.unsplash.com/photo-1556742031-c6961e8560b0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'personalization-at-scale'
}, {
  id: 11,
  title: 'Training Your AI Shopping Advisor: Best Practices',
  excerpt: 'Guidance on training your AI shopping advisor with product knowledge, brand voice, and sales strategies to maximize effectiveness.',
  date: 'March 10, 2023',
  author: 'Olivia Chen',
  category: 'Implementation',
  image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'training-ai-advisors'
}, {
  id: 12,
  title: 'AI Shopping Advisors vs. Traditional Chatbots',
  excerpt: 'A comparison of AI shopping advisors and traditional chatbots, highlighting key differences in capabilities, implementation, and results.',
  date: 'February 28, 2023',
  author: 'James Anderson',
  category: 'Technology Comparison',
  image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'ai-vs-chatbots'
}, {
  id: 13,
  title: 'Multi-Channel AI Strategy for Retail Brands',
  excerpt: 'How to create a cohesive AI strategy across your website, social media, messaging apps, and GPT Store for a seamless customer experience.',
  date: 'February 15, 2023',
  author: 'Sophia Martinez',
  category: 'Strategy',
  image: 'https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'multi-channel-ai'
}, {
  id: 14,
  title: 'Future Trends in AI-Powered Retail (2024-2025)',
  excerpt: 'Expert predictions on how AI will continue to transform retail experiences over the next two years, from voice commerce to AR integration.',
  date: 'January 30, 2023',
  author: 'Marcus Johnson',
  category: 'Trends',
  image: 'https://images.unsplash.com/photo-1535303311164-664fc9ec6532?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
  slug: 'future-ai-retail-trends'
}];
// Blog Home Page
const BlogHome = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const filteredPosts = searchQuery ? blogPosts.filter(post => post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) || post.category.toLowerCase().includes(searchQuery.toLowerCase())) : blogPosts;
  // Find featured post (the GPT Store guide)
  const featuredPost = blogPosts.find(post => post.featured === true) || blogPosts[0];
  const regularPosts = blogPosts.filter(post => post.id !== featuredPost.id);
  return <div className="bg-gradient-to-b from-indigo-50 to-white min-h-screen" data-id="element-119">
      <Helmet data-id="element-120">
        <title data-id="element-121">AI Retail Blog | Shopilots AI Shopping Advisors</title>
        <meta name="description" content="Latest insights, trends and strategies for implementing AI in retail and e-commerce to boost sales and enhance customer experience." data-id="element-122" />
        <meta name="keywords" content="AI retail, GPT Store, shopping advisors, conversational commerce, retail technology, AI implementation" data-id="element-123" />
        <meta name="ai:description" content="This blog provides in-depth articles about AI shopping advisors, GPT Store implementation, and retail AI strategy. Content is optimized for both traditional search and AI-powered discovery." data-id="element-124" />
        <script type="application/ld+json" data-id="element-125">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Blog",
              "name": "Shopilots AI Retail Blog",
              "description": "Latest insights, trends and strategies for implementing AI in retail and e-commerce",
              "url": "https://shopilots.com/blog",
              "publisher": {
                "@type": "Organization",
                "name": "Shopilots",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://uploadthingy.s3.us-west-1.amazonaws.com/rhREvAJ4b5296S85upFAnM/logonew.png"
                }
              }
            }
          `}
        </script>
      </Helmet>

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-purple-700 to-indigo-700 text-white py-16" data-id="element-126">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
          <div className="max-w-3xl mx-auto text-center" data-id="element-128">
            <BookOpenIcon className="h-12 w-12 mx-auto mb-4 text-indigo-200" data-id="element-129" />
            <h1 className="text-4xl font-extrabold mb-4" data-id="element-130">
              Shopilots AI Retail Blog
            </h1>
            <p className="text-xl text-indigo-100 mb-8" data-id="element-131">
              Latest insights, trends and strategies for implementing AI in
              retail and e-commerce
            </p>
            <div className="relative max-w-md mx-auto" data-id="element-132">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-133">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-134" />
              </div>
              <input type="text" className="w-full pl-10 pr-4 py-2 border-2 border-indigo-300 focus:border-indigo-500 focus:ring-indigo-500 rounded-full text-gray-900" placeholder="Search articles..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} aria-label="Search blog articles" data-id="element-135" />
            </div>
          </div>
        </div>
      </div>

      {/* Featured Post */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-136">
        <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-indigo-100 transform transition-all hover:shadow-2xl duration-300" data-id="element-137">
          <div className="md:flex" data-id="element-138">
            <div className="md:w-1/2" data-id="element-139">
              <img src={featuredPost.image} alt={`Featured article: ${featuredPost.title}`} className="h-full w-full object-cover" data-id="element-140" />
            </div>
            <div className="md:w-1/2 p-8" data-id="element-141">
              <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-142">
                <CalendarIcon className="h-4 w-4 mr-1" data-id="element-143" />
                <span data-id="element-144">{featuredPost.date}</span>
                <span className="mx-2" data-id="element-145">•</span>
                <UserIcon className="h-4 w-4 mr-1" data-id="element-146" />
                <span data-id="element-147">{featuredPost.author}</span>
              </div>
              <div className="inline-block bg-indigo-100 text-indigo-800 text-xs px-2 py-1 rounded-full mb-4" data-id="element-148">
                <TagIcon className="h-3 w-3 inline mr-1" data-id="element-149" />
                {featuredPost.category}
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-150">
                {featuredPost.title}
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-151">{featuredPost.excerpt}</p>
              <Link to={`/blog/${featuredPost.slug}`} data-id="element-152">
                <Button variant="primary" className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white" data-id="element-153">
                  Read Article
                  <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-154" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* SEO Strategy Banner */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-155">
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-indigo-100 shadow-sm" data-id="element-156">
          <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-157">
            <div className="mb-4 md:mb-0" data-id="element-158">
              <h3 className="text-xl font-semibold text-indigo-900" data-id="element-159">
                SEO Recommendations for AI Retail
              </h3>
              <p className="text-gray-700 max-w-2xl" data-id="element-160">
                Explore our comprehensive SEO strategy for AI-powered ecommerce
                platforms and GPT Store optimization.
              </p>
            </div>
            <Link to="/blog/seo-recommendations" data-id="element-161">
              <Button variant="outline" className="border-indigo-300 text-indigo-700 hover:bg-indigo-50" data-id="element-162">
                View SEO Strategy
                <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-163" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Recent Articles */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-164">
        <h2 className="text-3xl font-bold mb-8 text-gray-900" data-id="element-165">
          Recent Articles
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-166">
          {(searchQuery ? filteredPosts : regularPosts).map(post => <div key={post.id} className="bg-white rounded-xl overflow-hidden shadow-lg border border-gray-100 transform transition-all hover:shadow-xl duration-300 hover:-translate-y-1" data-id="element-167">
              <img src={post.image} alt={`Thumbnail for ${post.title}`} className="w-full h-48 object-cover" data-id="element-168" />
              <div className="p-6" data-id="element-169">
                <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-170">
                  <CalendarIcon className="h-4 w-4 mr-1" data-id="element-171" />
                  <span data-id="element-172">{post.date}</span>
                </div>
                <div className="inline-block bg-indigo-100 text-indigo-800 text-xs px-2 py-1 rounded-full mb-4" data-id="element-173">
                  {post.category}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-174">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3" data-id="element-175">
                  {post.excerpt}
                </p>
                <Link to={`/blog/${post.slug}`} data-id="element-176">
                  <span className="text-indigo-600 hover:text-indigo-800 font-medium inline-flex items-center" data-id="element-177">
                    Read More
                    <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-178" />
                  </span>
                </Link>
              </div>
            </div>)}
        </div>
      </div>

      {/* CTA Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-179">
        <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-xl p-8 md:p-12 text-center shadow-xl" data-id="element-180">
          <h2 className="text-3xl font-bold mb-4 text-white" data-id="element-181">
            Ready to implement AI in your retail business?
          </h2>
          <p className="text-xl text-indigo-100 mb-8 max-w-3xl mx-auto" data-id="element-182">
            Let our experts help you create a custom AI shopping advisor for
            your brand.
          </p>
          <Button variant="primary" size="lg" onClick={() => setIsWizardOpen(true)} className="bg-white text-indigo-700 hover:bg-indigo-50 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1" data-id="element-183">
            Get Started Today
          </Button>
        </div>
      </div>

      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-184" />
    </div>;
};
// Main Blog Component with Routes
const BlogIndex = () => {
  return <Routes data-id="element-185">
      <Route path="/" element={<BlogHome data-id="element-187" />} data-id="element-186" />
      <Route path="/seo-recommendations" element={<SEORecommendations data-id="element-189" />} data-id="element-188" />
      <Route path="/what-is-the-gpt-store" element={<WhatIsGPTStore data-id="element-191" />} data-id="element-190" />
      <Route path="/how-to-access-gpt-store" element={<HowToAccessGPTStore data-id="element-193" />} data-id="element-192" />
      <Route path="/:slug" element={<BlogPost data-id="element-195" />} data-id="element-194" />
    </Routes>;
};
export default BlogIndex;